import { ServiceBase } from "@app/shared";

interface SearchAddress {
  address: string;
  city: string;
  state: string;
  zip: string;
}

interface ResultAddress {
  address: string;
  censusZipClass: string;
  city: string;
  countyClass: string;
  geoInfo: GeoInfo;
  latitude: number;
  longitude: number;
  popDensityZipClass: string;
  standardCBSA: string;
  standardCity: string;
  standardCounty: string;
  standardZip: string;
  state: string;
  success: boolean;
  zip: string;
}

enum GeoInfo {
  unknown = "unknown",
  addressExact = "addressExact",
  addressRelaxed = "addressRelaxed",
  zipDistributive = "zipDistributive",
  zipLegacy = "zipLegacy",
  zipPoint = "zipPoint",
  invalidZip = "invalidZip",
  notInLicensedState = "notInLicensedState",
  correctedZipNotInLicensedState = "correctedZipNotInLicensedState",
  addressRelaxedZipMismatch = "addressRelaxedZipMismatch",
  failOnInvalidZip = "failOnInvalidZip",
  failOnNotInCountyClassFilter = "failOnNotInCountyClassFilter",
  failOnNotInServiceAreaFilter = "failOnNotInServiceAreaFilter",
  failOnNotInZipClassFilter = "failOnNotInZipClassFilter",
  notYetProcessed = "notYetProcessed",
}

/** Handles retrieval operations for geography information. */
export default class GeocoderService extends ServiceBase {
  public readonly geocodeAddress = async (searchAddress: SearchAddress): Promise<ResultAddress> => {
    return await this.makePost<ResultAddress>("geocode", searchAddress);
  }
}

export { GeoInfo, SearchAddress, ResultAddress };
